export default __webpack_public_path__ + "static/media/A5Select.819bdb36.svg";